<dx-data-grid
  style="height: 100%"
  [(dataSource)]="containers"
  keyExpr="id"
  [showBorders]="true"
  [remoteOperations]="false"
  [allowColumnResizing]="true"
  [allowColumnReordering]="true"
  [rowAlternationEnabled]="true"
  (onRowUpdated)="onRowUpdated($event)"
  (onRowRemoved)="onRowRemoved($event)"
  (onRowInserted)="onRowUpdated($event)"
  (onToolbarPreparing)="onToolbarPreparing($event)"
>
  <dxo-search-panel [visible]="true" [highlightCaseSensitive]="true"></dxo-search-panel>
  <dxo-group-panel [visible]="true"></dxo-group-panel>
  <dxo-grouping [autoExpandAll]="false"></dxo-grouping>
  <dxo-column-chooser [enabled]="true"></dxo-column-chooser>
  <dxo-scrolling mode="standard" [useNative]="false"></dxo-scrolling>
  <dxo-state-storing [enabled]="true" type="localStorage" storageKey="dataProcessImport"></dxo-state-storing>
  <dxo-paging [enabled]="true"></dxo-paging>
  <dxo-pager [showPageSizeSelector]="true" [allowedPageSizes]="[5, 10, 20]" />

  <div *dxTemplate="let toolbaritem of 'newDataProcessButtonTemplate'">
    <div id="addButton" class="d-flex gap-2">
      <dx-button
        stylingMode="text"
        type="default"
        icon="plus"
        text="{{ 'Container hinzufügen' | translate }}"
        (onClick)="showAddContainer($event)"
      ></dx-button>
    </div>
  </div>

  <dxi-column dataField="name"></dxi-column>
  <dxi-column caption="" cellTemplate="editTemplate" alignment="right">
    <div *dxTemplate="let edit of 'editTemplate'">
      <dx-button icon="edit" (onClick)="toogglePopUp($event, edit.data)"></dx-button>
      <dx-button icon="trash" (onClick)="removeContainer($event, edit.data)"></dx-button>
    </div>
  </dxi-column>
  <dxo-master-detail [enabled]="true" template="detail" />
  <div *dxTemplate="let container of 'detail'">
    <np-catalog-cards stage="import" [containerId]="container.data.id" />
  </div>
</dx-data-grid>

<dx-popup
  [(visible)]="editPopUpVisible"
  [hideOnOutsideClick]="true"
  showTitle="true"
  title="{{ 'Container Information' | translate }}"
>
  <dx-tab-panel>
    <dxi-item title="{{ 'Informationen' | translate }}">
      <div *dxTemplate>
        <div class="np-form-control dx-fieldset" *ngIf="selectedContainer">
          <div class="dx-field">
            <div class="dx-field-label">{{ 'Name' | translate }}</div>
            <div class="dx-field-value">
              <dx-text-box
                [(value)]="selectedContainer.name"
                (onValueChanged)="update(selectedContainer)"
                label="{{ 'Name' | translate }}"
              ></dx-text-box>
            </div>
          </div>

          <div class="dx-field">
            <div class="dx-field-label">{{ 'Description' | translate }}</div>
            <div class="dx-field-value">
              <dx-html-editor
                [(value)]="selectedContainer.description"
                allowSoftLineBreak="true"
                (onValueChanged)="update(selectedContainer)"
              >
                <dxo-toolbar>
                  <dxi-item name="undo"></dxi-item>
                  <dxi-item name="redo"></dxi-item>
                  <dxi-item name="separator"></dxi-item>
                  <dxi-item name="bold"></dxi-item>
                  <dxi-item name="italic"></dxi-item>
                  <dxi-item name="strike"></dxi-item>
                  <dxi-item name="underline"></dxi-item>
                  <dxi-item name="separator"></dxi-item>
                  <dxi-item name="alignLeft"></dxi-item>
                  <dxi-item name="alignCenter"></dxi-item>
                  <dxi-item name="alignRight"></dxi-item>
                  <dxi-item name="alignJustify"></dxi-item>
                  <dxi-item name="separator"></dxi-item>
                  <dxi-item name="header" [acceptedValues]="[1, 2, 3, 4, 5, false]"></dxi-item>
                  <dxi-item name="separator"></dxi-item>
                  <dxi-item name="orderedList"></dxi-item>
                  <dxi-item name="bulletList"></dxi-item>
                  <dxi-item name="separator"></dxi-item>
                  <dxi-item name="link"></dxi-item>
                </dxo-toolbar>
              </dx-html-editor>
            </div>
          </div>

          <div class="dx-field">
            <div class="dx-field-label">{{ 'QuellTyp' | translate }}</div>
            <div class="dx-field-value">
              <dx-select-box
                [(value)]="selectedContainer.sourceType"
                [items]="sourceTypes"
                [valueExpr]="'value'"
                [displayExpr]="'text'"
                (onValueChanged)="update(selectedContainer)"
                label="{{ 'QuellTyp' | translate }}"
              ></dx-select-box>
            </div>
          </div>

          <div
            class="dx-field"
            *ngIf="selectedContainer.sourceType == 'Manufacturer' || selectedContainer.sourceType == 'Supplier'"
          >
            <div class="dx-field-label">
              {{ 'QuellDetails' | translate : { quelltyp: selectedContainer.sourceType } }}
            </div>
            <div class="dx-field-value">
              <dx-select-box
                [(value)]="selectedContainer.sourceDetails"
                [valueExpr]="'name'"
                [displayExpr]="'name'"
                [items]="sourceDetails"
                label="{{ 'QuellDetails' | translate : { quelltyp: selectedContainer.sourceType } }}"
                (onValueChanged)="update(selectedContainer)"
              ></dx-select-box>
            </div>
          </div>

          <div class="dx-field">
            <div class="dx-field-label">{{ 'Icon' | translate }}</div>
            <div class="dx-field-value">
              <div class="d-flex align-items-start gap-3">
                <span
                  *ngIf="!uploadIcon"
                  class="glyphicon glyphicon-picture"
                  [ngStyle]="{ fontSize: '5ch', marginBlock: '2rem' }"
                ></span>
                <div
                  *ngIf="uploadIcon"
                  class="logo-preview d-flex justify-content-center align-items-center position-relative"
                >
                  <img [src]="uploadIcon" alt="Logo Preview" class="img-thumbnail" />
                  <dx-button
                    class="position-absolute top-0 end-0 mt-2 me-2"
                    icon="clear"
                    (click)="clearIcon()"
                  ></dx-button>
                </div>
                <dx-file-uploader
                  uploadUrl="api/DataProcessContainer/UploadIcon"
                  [allowedFileExtensions]="['.jpg', '.jpeg', '.png', '.gif']"
                  [uploadHeaders]="uploadHeaders"
                  [uploadCustomData]="{
                    id: selectedContainer.id,
                    customerId: loginService.currentUser.customerId
                  }"
                  [multiple]="false"
                  accept="*"
                  (onUploaded)="onUploaded()"
                  (onBeforeSend)="onBeforeSendUpload($event)"
                  [(value)]="value"
                  uploadMode="instantly"
                ></dx-file-uploader>
              </div>
            </div>
          </div>

          <div class="dx-field">
            <div class="dx-field-label">{{ 'ImportModus' | translate }}</div>
            <div class="dx-field-value">
              <div class="d-flex flex-row pt-2">
                <div class="dx-field-label switch-left">{{ 'Manuel' | translate }}</div>
                <dx-switch
                  [(value)]="selectedContainer.importMode"
                  (onValueChanged)="update(selectedContainer)"
                ></dx-switch>
                <div class="dx-field-label switch-right">{{ 'Automatisch' | translate }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </dxi-item>

    <dxi-item title="{{ 'Datenanalyse' | translate }}">
      <div *dxTemplate class="np-form-control dx-fieldset"></div>
    </dxi-item>

    <dxi-item title="{{ 'Templates' | translate }}">
      <div *dxTemplate class="np-form-control dx-fieldset">
        <templateList [containerId]="selectedContainer.id"></templateList>
      </div>
    </dxi-item>

    <dxi-item title="{{ 'Mappings' | translate }}">
      <div *dxTemplate>
        <div class="np-form-control dx-fieldset" *ngIf="selectedContainer">
          <dx-toolbar>
            <dxi-item
              location="before"
              widget="dxButton"
              locateInMenu="auto"
              [options]="newMappingListOption"
            ></dxi-item>
          </dx-toolbar>

          <wawiLists [containerId]="selectedContainer.id"></wawiLists>

          <div class="dx-field">
            <div class="dx-field-value">
              <div class="d-flex flex-row pt-2">
                <dx-switch
                  [(value)]="selectedContainer.transferIntoNextStage"
                  (onValueChanged)="update(selectedContainer)"
                ></dx-switch>
                <div class="dx-field-label switch-right">
                  {{ 'Bei Übertragung in nächste Stage anwenden' | translate }}
                </div>
              </div>
            </div>
          </div>

          <div class="dx-field">
            <div class="dx-field-label align-items-start">{{ 'Mapping' | translate }}</div>
            <div class="dx-field-value">
              <wawiMappingChooser
                [fields]="wawiMappingFields"
                [fieldGroups]="fieldGroups"
                [(exportParameter)]="config"
                exportMode="true"
                [ngStyle]="{ height: 'inherit' }"
              ></wawiMappingChooser>
            </div>
          </div>
        </div>
      </div>
    </dxi-item>

    <dxi-item title="{{ 'Makros' | translate }}">
      <div *dxTemplate class="np-form-control dx-fieldset"></div>
    </dxi-item>
  </dx-tab-panel>
</dx-popup>

<dx-popup
  width="600"
  height="400"
  [(visible)]="addMappingListEnabled"
  [hideOnOutsideClick]="true"
  [showCloseButton]="true"
  showTitle="true"
  title="{{ 'Neue Liste hinzufügen' | translate }}"
>
  <dx-tab-panel>
    <dxi-item title="{{ 'Bestehender Liste' | translate }}">
      <div class="np-form-control dx-fieldset" *ngIf="selectedContainer">
        <div class="dx-field">
          <div class="dx-field-label">{{ 'Aus bestehenden Listen wählen' | translate }}</div>
          <div class="dx-field-value">
            <dx-select-box
              [items]="mappings"
              [(value)]="selectedWawiList"
              displayExpr="listName"
              keyExpr="id"
              (onValueChanged)="update(selectedContainer)"
              label="{{ 'auswählen' | translate }}"
            ></dx-select-box>
          </div>
        </div>
      </div>
      <!-- <dx-button
        icon="plus"
        text="{{ 'Kopie erstellen' | translate }}"
        (onClick)="onCopyMappingList($event)"
      ></dx-button> -->
      <dx-button
        icon="plus"
        text="{{ 'Mit Container verknüpfen' | translate }}"
        (onClick)="onReferenceMappingList($event)"
      ></dx-button>
    </dxi-item>
    <dxi-item title="{{ 'Neue Liste' | translate }}">
      <div class="np-form-control dx-fieldset" *ngIf="selectedContainer">
        <div class="dx-field">
          <div class="dx-field-label">{{ 'Aus bestehenden Listen wählen' | translate }}</div>
          <div class="dx-field-value">
            <dx-text-box
              [(value)]="mappingListName"
              (onValueChanged)="update(selectedContainer)"
              label="{{ 'auswählen' | translate }}"
            ></dx-text-box>
          </div>
        </div>
      </div>
      <dx-button icon="plus" text="{{ 'Hinzufügen' | translate }}" (onClick)="onAddMappingList($event)"></dx-button>
    </dxi-item>
  </dx-tab-panel>
</dx-popup>
